import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss'
})
export class BadgeComponent {
  /// input para el texto del badge como una propiedad del componente
  @Input() text: string = 'Badge';

}
